
export const videoURL1 = "https://d3v34xxa99dhvk.cloudfront.net/GoRead-video-boy-only.mp4"
export const videoURL = "https://drive.google.com/file/d/1AQohpUDOj0ZKBQf0dVw_BaGQSp2elcpN/view?usp=sharing"